// Adapter to propagate the value of ActiveRoute out of the top of the
// application stack.

import IRoute from 'app/constants/Routes/IRoute';
import { createContext, FunctionComponent, useContext } from 'react';
import { useActiveRoute } from '../router/ActiveRoute';

export class SelectedRoute {
  public id: string | undefined;

  public setSelectedRoute(route: IRoute | undefined) {
    this.id = route?.id;
  }
}

const SelectedRouteContext = createContext<SelectedRoute | undefined>(undefined);

export const ProvideSelectedRoute = SelectedRouteContext.Provider;
export const useSelectedRoute = () => useContext(SelectedRouteContext);

export const SelectedRouteUpdater: FunctionComponent = () => {
  const { route } = useActiveRoute();
  const selectedRoute = useSelectedRoute();

  if (selectedRoute) {
    selectedRoute.setSelectedRoute(route);
  }

  return null;
};
